/**
 * @group Data
 * @summary Data access level descriptions and related messages
 * 
 * @remarks
 * This constant contains descriptions for data access levels used in the
 * permission system to define what records a user can access.
 * 
 * @example
 * ```typescript
 * import { DATA_ACCESS_LEVEL_DESCRIPTIONS } from '@shared/constants';
 * 
 * const accessLevel = user.permission?.accessLevel || 'none';
 * const description = DATA_ACCESS_LEVEL_DESCRIPTIONS[accessLevel];
 * ```
 */
export const /**
 * @internal
 */
DATA_ACCESS_LEVEL_DESCRIPTIONS = {
  none: 'No access to records',
  own: 'Access to own records only',
  tenant: 'Access to records within same tenant',
  role: 'Access to records with specific role relationship',
  all: 'Access to all records',
  unknown: 'Unknown access level'
} as const; 